import script from "./AnnouncementCard.vue?vue&type=script&setup=true&lang=js"
export * from "./AnnouncementCard.vue?vue&type=script&setup=true&lang=js"

import "./AnnouncementCard.vue?vue&type=style&index=0&id=6f9faf99&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f9faf99"]])

export default __exports__